// campaign-series.ts — pure helpers for recurring-campaign (FE#240) SERIES
// semantics against the ORCH#102 relaunch chain.

/** A campaign is a live recurring SERIES iff it carries both flags the engine
 *  gate reads. (isRecurring alone, or a rule alone, does not relaunch.) */
export function isRecurringCampaign(
  campaign: { schedule?: { isRecurring?: boolean; rruleset?: string } | null } | null | undefined,
): boolean {
  const s = campaign?.schedule;
  return Boolean(s?.isRecurring && s?.rruleset);
}

/** The schedule write that STOPS future relaunches: clear isRecurring, keep
 *  everything else (rruleset/dueDate preserved so history/inspection is intact).
 *  Generic so it returns the caller's own schedule type. */
export function stopRecurrenceSchedulePatch<T extends object>(
  schedule: T | null | undefined,
): T & { isRecurring: false } {
  return { ...(schedule ?? ({} as T)), isRecurring: false };
}
